import partial from 'lodash/partial';
import unionBy from 'lodash/unionBy';
import { LocationService } from 'shared/services';
import { LocationModel } from 'shared/models';
import { createDispatchFunction } from 'shared/helpers';

//  Actions
const GET_LOCATION = 'location/GET_LOCATION';
const UPDATE_LOCATION = 'location/UPDATE_LOCATION';
const UPDATE_LOCATIONS = 'location/UPDATE_LOCATIONS';
const DELETE_LOCATION = 'location/DELETE_LOCATION';
const initialState = {
  current: {},
  locations: [],
  error: null,
  loading: false,
}
//  Reducer
export default function locationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LOCATION:
      return {
        ...state,
        current: action.result.data,
      };
    case UPDATE_LOCATION:
      return {
        ...state,
        locations: unionBy([action.result.data], state.locations, 'id'),
      };
    case DELETE_LOCATION: 
    return {
      ...state,
      locations: state.locations.splice(state.locations.indexOf(location), 1)
    };
    default:
      return state;
  }
}

// Action Creators
export function getLocationAction(result) {
  return { type: GET_LOCATION, result };
}

export function updateLocationAction(result) {
  return { type: UPDATE_LOCATION, result };
}

export function updateLocationsAction(result) {
  return { type: UPDATE_LOCATIONS, result };
}

export function deleteLocationAction(result) {
  return { type: DELETE_LOCATION, result };
}

//  Action dispatcher functions
export function getLocation(locationId) {
  return createDispatchFunction(
    partial(LocationService.getLocation, locationId),
    getLocationAction
  );
}

export function updateLocation(data) {
  return createDispatchFunction(
    partial(LocationService.updateLocation, data),
    updateLocationAction
  );
}

export function deleteLocation(data) {
  return createDispatchFunction(
    partial(LocationService.deleteLocation, data),
    deleteLocationAction
  );
}

export function updateLocations(data) {
  return function (dispatch) {
    return LocationService.updateLocations(data)
      .then((response) => {
        dispatch(updateLocationsAction({
          loading: false,
          error: null,
          data: response,
        }));
        return response;
      })
      .catch((error) => {
        dispatch(updateLocationsAction({
          loading: false,
          error,
          data: [],
        }));
      });
  };
}
